import { Routes } from '@angular/router';
import { permissionGuard } from '@core/guards';
import { firebaseAuthResolver } from '@shared/services';

import { mapLibraryResolver } from '@shared/services/map-loader.resolver';
import { EGoogleLib } from '@shared/models/configurations.interface';
import { DialogService } from 'primeng/dynamicdialog';

export const requestRoutes: Routes = [
  {
    path: 'requests',
    loadComponent: () =>
      import('@feature/customer/requests/request.component').then(
        m => m.RequestComponent
      ),
    resolve: {
      firebase: firebaseAuthResolver,
      lib: mapLibraryResolver(EGoogleLib.places),
    },
    providers: [DialogService],
    children: [
      {
        path: 'routing-requests',
        canActivate: [permissionGuard('DispatcherRoutingRequestsView')],
        loadComponent: () =>
          import('./routing-requests/routing-requests.component').then(
            m => m.RoutingRequestsComponent
          ),
      },
      {
        path: 'video-requests',
        canActivate: [permissionGuard('DispatcherVideoRequestsView')],
        loadComponent: () =>
          import('./video-requests/video-requests.component').then(
            m => m.VideoRequestsComponent
          ),
      },
    ],
  },
];
